import { ObjectId } from "bson";
import { ResponseInputItem, ResponseOutputItem, ResponseTextConfig } from 'openai/resources/responses/responses.mjs';
import { ReasoningEffort } from "openai/resources/shared.mjs";
import { MID, SDATE } from "./index.js";
import { ToolConfig } from "./ToolConfig.js";



export const GptChatModelTypeArr = ["gpt-4o", "gpt-4o-mini", "gpt-4.1", "gpt-4.1-mini", "gpt-4.1-nano", "gpt-5", "gpt-5-mini", "gpt-5-nano", "gpt-5.1", "gpt-5.2", "gpt-5.4", "gpt-5.4-mini", "gpt-5.4-nano", "gpt-5.5", "gpt-5.5-pro", "gpt-5.6", "gpt-5.6-sol", "gpt-5.6-terra", "gpt-5.6-luna", "gpt-6-astra"] as const;
export type GTPChatModelType = typeof GptChatModelTypeArr[number];

// gpt-5*/gpt-6*-Modelle: Temperature/TextVerbosity nicht einstellbar, Reasoning-Effort verfügbar
export function isReasoningModel(model: string): boolean {
  return model.startsWith('gpt-5') || model.startsWith('gpt-6');
}

// Bitte Alphabetisch halten, dann brauchen wir nicht .sort()
export const OLlamaChatModelTypeArr = ["deepseek-r1:8b", "deepseek-r1:14b", "gemma3:4b", "llama3.2:3b", "mistral:7b", "qwen2.5vl:7b", "gpt-oss:20b"] as const;
export type OLlamaChatModelType = typeof OLlamaChatModelTypeArr[number];


export const VLLMChatModelTypeArr = ["Qwen3.8-27B"] as const;
export type VLLMChatModelType = typeof VLLMChatModelTypeArr[number];

export const ElevenLabsModelTypeArr = ["eleven_multilingual_v2", "eleven_flash_v2_5", "eleven_turbo_v2_5"] as const;
export type ElevenLabsModelType = typeof ElevenLabsModelTypeArr[number];

export const reasoningEffortOptions: { id: number; name: string; value: string | null; supported: string[]; }[] = [
  { id: 0, name: '-', value: null, supported: [] },
  { id: 1, name: 'None', value: 'none', supported: ['gpt-5.1', 'gpt-5.2', 'gpt-5.4', 'gpt-5.4-mini', 'gpt-5.4-nano', 'gpt-5.5', 'gpt-5.6', 'gpt-5.6-sol', 'gpt-5.6-terra', 'gpt-5.6-luna', "Qwen/Qwen3-8B-AWQ"] },
  { id: 2, name: 'Minimal', value: 'minimal', supported: ['gpt-5', 'gpt-5-mini', 'gpt-5-nano', 'Qwen/Qwen3-8B-AWQ'] },
  { id: 3, name: 'Low', value: 'low', supported: ['gpt-5', 'gpt-5-mini', 'gpt-5-nano', 'gpt-5.1', 'gpt-5.2', 'gpt-5.4', 'gpt-5.4-mini', 'gpt-5.4-nano', 'gpt-5.5', 'gpt-5.6', 'gpt-5.6-sol', 'gpt-5.6-terra', 'gpt-5.6-luna', 'gpt-6-astra', 'Qwen/Qwen3-8B-AWQ'] },
  { id: 4, name: 'Medium', value: 'medium', supported: ['gpt-5', 'gpt-5-mini', 'gpt-5-nano', 'gpt-5.1', 'gpt-5.2', 'gpt-5.4', 'gpt-5.4-mini', 'gpt-5.4-nano', 'gpt-5.5', 'gpt-5.5-pro', 'gpt-5.6', 'gpt-5.6-sol', 'gpt-5.6-terra', 'gpt-5.6-luna', 'gpt-6-astra', 'Qwen/Qwen3-8B-AWQ'] },
  { id: 5, name: 'High', value: 'high', supported: ['gpt-5', 'gpt-5-mini', 'gpt-5-nano', 'gpt-5.1', 'gpt-5.2', 'gpt-5.4', 'gpt-5.4-mini', 'gpt-5.4-nano', 'gpt-5.5', 'gpt-5.5-pro', 'gpt-5.6', 'gpt-5.6-sol', 'gpt-5.6-terra', 'gpt-5.6-luna', 'gpt-6-astra', 'Qwen/Qwen3-8B-AWQ'] },
  { id: 6, name: 'X-High', value: 'xhigh', supported: ['gpt-5.2', 'gpt-5.4', 'gpt-5.4-mini', 'gpt-5.4-nano', 'gpt-5.5', 'gpt-5.5-pro', 'gpt-5.6', 'gpt-5.6-sol', 'gpt-5.6-terra', 'gpt-5.6-luna', 'gpt-6-astra', 'Qwen/Qwen3-8B-AWQ'] },
  { id: 7, name: 'Max', value: 'max', supported: ['gpt-5.6', 'gpt-5.6-sol', 'gpt-5.6-terra', 'gpt-5.6-luna', 'gpt-6-astra', 'Qwen/Qwen3-8B-AWQ'] }
];

// Im europäischen Raum relevante Sprachen, unterstützt vom faster-whisper-large-v3-turbo Modell
export const SpeechRecognitionLanguageArr = [
  "auto", "en", "de", "fr", "es", "it", "pt", "nl", "sv", "da", "no", "fi",
  "pl", "cs", "sk", "hu", "ro", "bg", "el", "ru", "uk", "be", "hr", "sr",
  "bs", "sl", "mk", "sq", "lt", "lv", "et", "tr", "ar", "vi", "zh"
] as const;
export type SpeechRecognitionLanguage = typeof SpeechRecognitionLanguageArr[number];

// Sprachen, in denen die bot-App gebaut wird (siehe bot/angular.json i18n.locales)
export const BotLocaleArr = [
  "de", "en", "fr", "es", "it", "nl", "nb-no", "fr-be", "nl-be",
  "pl", "pt", "hu", "ro", "tr", "fi", "sv", "da", "cs", "el"
] as const;
export type BotLocale = typeof BotLocaleArr[number];
// Pro Bot-Sprache hinterlegbarer Text, fehlende Sprachen werden nicht angezeigt (kein Fallback)
export type LocalizedBotText = Partial<Record<BotLocale, string>>;

export type SpeechRecognitionMode = "locale" | "auto";
// Ordnet jede Bot-Sprache dem passenden Whisper-Sprachcode zu (z.B. nb-no/fr-be/nl-be haben keinen
// eigenen Whisper-Code) - Record<BotLocale, ...> erzwingt zur Compile-Zeit, dass kein BotLocale fehlt.
export const botLocaleToSpeechRecognitionLanguage: Record<BotLocale, SpeechRecognitionLanguage> = {
  de: "de", en: "en", fr: "fr", es: "es", it: "it", nl: "nl", "nb-no": "no",
  "fr-be": "fr", "nl-be": "nl", pl: "pl", pt: "pt", hu: "hu", ro: "ro",
  tr: "tr", fi: "fi", sv: "sv", da: "da", cs: "cs", el: "el"
};

export type ElevenLabsVoiceConfig = {
  id: string
  stability: number,
  use_speaker_boost: boolean,
  similarity_boost: number,
  style: number,
  speed: number,
  model: ElevenLabsModelType
}

// Einzelner Slot der Fullscreen-Header-Leiste: entweder Bild-URL, Text oder leer - nie beides gleichzeitig.
export type AvatarFullscreenHeaderSlot = {
  kind: 'none' | 'image' | 'text',
  value: string
}

export type AvatarFullscreenConfig = {
  active: boolean,
  header: {
    left: AvatarFullscreenHeaderSlot,
    center: AvatarFullscreenHeaderSlot,
    right: AvatarFullscreenHeaderSlot
  }
}

export type LiveAvatarConfig = {
  avatarId: string,
  avatarName: string,
  avatarPreviewUrl: string,
  backgroundUrl: string,
  useGreenscreen: boolean,
  voiceConfig: ElevenLabsVoiceConfig
  promptbarActive: boolean
  voiceInputActive: boolean
  switchToChat: boolean
  switchToVoice: boolean
  cancelBotThinkingActive: boolean
  // Optional, da bestehende Bots dieses Feld noch nicht besitzen (kein DB-Migrationsschritt, siehe ensureLiveAvatarConfig()).
  fullscreenConfig?: AvatarFullscreenConfig

}

export type DIdAvatarConfig = {
  avatarId: string,
  avatarName: string,
  avatarPreviewUrl: string,
  // D-ID Idle-Video des gewaehlten Avatars (hoeher aufgeloest als avatarPreviewUrl), fuer eine schaerfere
  // statische Vorschau vor Verbindungsaufbau. Nur gesetzt, wenn D-ID eines liefert.
  avatarIdleVideoUrl?: string,
  backgroundUrl: string,
  // Nur wirksam, wenn der gewaehlte Avatar isGreenscreen unterstuetzt (siehe DIdAgentConf).
  useGreenscreen: boolean,
  promptbarActive: boolean,
  voiceInputActive: boolean,
  switchToChat: boolean,
  switchToVoice: boolean,
  cancelBotThinkingActive: boolean,
  // Optional, da bestehende Bots dieses Feld noch nicht besitzen (kein DB-Migrationsschritt, siehe ensureDIdAvatarConfig()).
  fullscreenConfig?: AvatarFullscreenConfig,
}

export const GptTTSModelTypeArr = ["tts-1", "gpt-4o-mini-tts"] as const;
export const GptModelTypeArrWithTTS = [...GptChatModelTypeArr, ...GptTTSModelTypeArr, "heygen_streaming_avatar", "did_streaming_avatar"] as const;
export type Model = typeof GptModelTypeArrWithTTS[number];

export type SupervisorFunction = {
  id: string
  name: string,
  js: string
}

export type ThreadSummaryItem<ID extends MID = string, DATE extends SDATE = string> = {
  _id: ID,
  threadId: string,
  botId: ID
  content: string,
  created: DATE
  finished: boolean
}

namespace ModelConfig {
  export type OpenAiModelConfig = {
    model: GTPChatModelType,
    modelSource: "openai"
  }
  export type VLLMModelConfig = {
    model: VLLMChatModelType,
    modelSource: "vllm"
  }
}
/*
tools: [
{
managed: true
  type: "mcp",
server_label: "Tool 1",
server_description: "Description of Tool 1",
server_url: "https://tool1.example.com/api",




allowed_tools: ["toolA", "toolB"],
require_approval: "always",
tool_names_without_approval: ["toolA"]
}
]
*/

export type TemplateVarDefaults = {
  name: string,
  description: string,
  isAiVariable?: boolean,
  showInWizard?: boolean,
  deleteAfterTemplateUsage?: boolean,
}
export type TeamplateVarNumber = TemplateVarDefaults & {
  type: "number"
  value: number
}
export type TeamplateVarString = TemplateVarDefaults & {
  type: "string"
  value: string
}
export type TeamplateVarBoolean = TemplateVarDefaults & {
  type: "boolean"
  value: boolean
}
export type TemplateVar = TeamplateVarNumber | TeamplateVarString | TeamplateVarBoolean

export type ChatbotConfig<ID extends MID = string, DATE extends SDATE = string> =
  (
    ModelConfig.OpenAiModelConfig |
    ModelConfig.VLLMModelConfig
  ) & {
    _id: ID,
    projectId: ID | null,
    activeDocSearch: boolean,
    activeDocSearchCount: number,
    activeDocSearchMinScore: number,
    activeDocSearchType: "vector" | "text" | "combined",
    // Merkt sich Ergebnisse vergangener aktiver Dokumentsuchen ueber mehrere Chat-Runs hinweg.
    // Fuer Dokumente als einzelne Tools gibt es ein eigenes Flag pro Dokument (SearchDoc.docSearchMemoryEnabled),
    // fuer die Nutzer-Dokumente-Suche das eigene userDocumentsMemoryEnabled weiter unten.
    activeDocSearchMemoryEnabled: boolean,
    activeDocSearchMemoryLimit: number,
    allowUserFileUpload: boolean,
    archived: boolean,
    assistantId?: string | null,
    assistantUpdatedDate?: DATE | null,
    botInstruction: string,
    botPassword: string,
    cancelBotThinkingAvatarActive: boolean,
    cancelBotThinkingChatActive: boolean,
    cancelBotThinkingVoiceActive: boolean,
    changeHistory: string,
    chatMsgSourceOption: 'hidden' | 'visible' | 'linking',
    complianceText: LocalizedBotText,
    createEmptyThreadOnVisit: boolean,
    creator?: ID,
    creatorName: string,
    created: DATE,
    customCss: string,
    customChatCss: string,
    customVoiceCss: string,
    customAvatarCss: string,
    customDidAvatarCss: string,
    customJs: string,
    currentOrg: string,
    color: string,
    deleteGuestsAfterDays: number,
    documentationUrl: string,
    enableMessageFeedback: boolean,
    enableInstantAccess: boolean,
    helpUrls: string,
    heygenApiKey: string,
    heyGenAvatarId: string,
    heyGenEnabled: boolean,
    heyGenVoiceId: string,
    heyGenBackgroundUrl: string,
    icon?: string,
    isDemo?: boolean,
    isPublic: boolean,
    isPwProtected: boolean,
    isTemplate?: boolean,
    isTemplateDraft?: boolean,
    hasImage: boolean,
    hasImageOpen: boolean, // Fusion-View-Button-Bild für den geöffneten Zustand
    liveAvatarConfig?: LiveAvatarConfig,
    didAvatarConfig?: DIdAvatarConfig,
    memoryEnabled: boolean, // wird noch gelöscht
    messageCopyChatActive: boolean,
    messageDeleteChatActive: boolean,
    name: string,
    promptbarAvatarActive: boolean,
    promptbarChatActive: boolean,
    promptbarAudioActive: boolean,
    quarantine?: {
      isQuarantined: boolean,
      quarantinedAt: SDATE,
      message: string,
      quarantineType: "response" | "chatcompletion"
    },
    secondsToWaitForThreadDeleting: number,
    showChangeHistory: boolean,
    skipQuarantineUntil: SDATE,
    speechRecognitionMode: SpeechRecognitionMode,
    stopWords: string[],
    storageaccessText: LocalizedBotText,
    summarizePrompt: string,
    supervisorEnabled: boolean,
    supervisorFunctions: SupervisorFunction[],
    switchToAvatarFromChat: boolean,
    switchToAvatarFromVoice: boolean,
    switchToChatFromAvatar: boolean,
    switchToChatFromVoice: boolean,
    switchToVoiceFromChat: boolean,
    switchToVoiceFromAvatar: boolean,
    tagList: string[],
    temperature: number,
    templateVars: TemplateVar[],
    templateDescription?: string,
    textVerbosity: ResponseTextConfig['verbosity'],
    postMessageTargetOrigin: string,
    thisIsTrash: boolean,
    toolConfigs: ToolConfig[],
    updator?: string,
    updated: DATE,
    usage: {
      completion_tokens: number,
      prompt_tokens: number,
      total_tokens: number
    },
    voiceInputAvatarActive: boolean,
    voiceInputChatActive: boolean,
    voiceInputVoiceActive: boolean,
    voiceOutputChatActive: boolean,
    voiceConfig: ElevenLabsVoiceConfig,
    voiceAutoPlay: boolean,
    loadingMessages: string,
    userDocumentsEnabled: boolean,
    userDocumentsMaxCount: number,
    userDocumentsMaxMb: number,
    userDocumentsMemoryEnabled: boolean,
    userDocumentsMemoryLimit: number,
    websearch: boolean,
    wordReplacements: WordReplacement[],
    currentProjectUserIds: ID[],
    reasoningEffort: ReasoningEffort
  };

export type OfflineWebParam = {
  description: string;
  required: boolean;
  type: "string" | "number" | "boolean";
  key: string;
};

export const OutputTriggerTypeArr = ["wordrecognition", "userwordrecognition", "always"] as const;
export type OutputTrigger = typeof OutputTriggerTypeArr[number]

export type TriggerResult = {
  name: string,
  value: string,
  action: TriggerAction
}

export const TriggerActionArr = ["opennextpreset", "markpresetdone", "alert", "autoanswer", "systemmessage", "proposedone"] as const;
export type TriggerAction = typeof TriggerActionArr[number]

export const ParserTypeArr = ["text", "json"] as const;
export type ParserType = typeof ParserTypeArr[number]

export type TriggerConf = {
  type: OutputTrigger,
  stopword: string,
  name: string
  autoAnswerText: string,
  parser: "text" | "json"
  action: TriggerAction
}

export const ChatDialogServerCommArr = ['assistant', 'system', 'user', 'developer', 'botcard', 'doc-search', 'mcp_approval_request', 'mcp_approval_response', 'mcp_call'] as const;
export type ChatDialogServerComm = typeof ChatDialogServerCommArr[number];
export type MsgRole = ChatDialogServerComm



export type ChatModelError = {
  error: {
    message: string;
    type: string;
    param: string;
    code: string;
  };
};


export type MessageContent = {
  type: 'text',
  text: string
} | {
  type: "image",
  image_url: string
} | ResponseOutputItem.McpApprovalRequest
  | ResponseInputItem.McpApprovalResponse
  | ResponseOutputItem.McpCall

export type MessageItem = {
  role: ChatDialogServerComm,
  content: MessageContent[]
}

export type ChatMessageRequestBody = {
  message: (MessageItem & { bypass?: boolean; })[]
  history: (MessageItem & { bypass?: boolean; })[]
  /** Nur bei Avatar-Turns gesetzt, verknüpft Client- und Server-Latenzmessung. */
  turnId?: string
}
export type DialogMessage = MessageItem & {
  hidden?: boolean,
  bypass?: boolean,
  docSearchSourceType?: 'active' | 'document' | 'userDocuments';
  docSearchSourceDocId?: string;
}
export type HistoryItemResponse<ID = string> = MessageItem & {
  _id: ID;
  bypass?: boolean;
  reasoning?: string;
  context: HistoryItemContext;
  created: Date;
  memoryEnabled: boolean
  threadId: string;
  item_id: string,
  supervisorEnabled: boolean;
  // Nur bei role 'doc-search' gesetzt: woher das Suchergebnis stammt, damit beim Re-Injizieren
  // ins LLM-Gespraech pro Quelle (aktive Suche / einzelnes Dokument / Nutzer-Dokumente) das jeweils
  // passende Memory-Flag+Limit angewendet werden kann.
  docSearchSourceType?: 'active' | 'document' | 'userDocuments';
  docSearchSourceDocId?: string;
}

export type DocSearchHistorySource =
  | { type: 'active' }
  | { type: 'userDocuments' }
  | { type: 'document', docId: string };

export type AdminMessage<ID = string> = {
  _id: ID;
  context: HistoryItemContext;
  content: string;
  userAnswer: string;
  threadId: string;
  created: Date;
  creator: string;
}

// SCHEMA ANGEPASST
export type SummaryItem<ID = string> = {
  _id: ID,
  content: string,
  context: HistoryItemContext,
  created: Date,
  embeddings?: number[]
  summarizedMessages: ID[],
}

// SCHEMA ANGEPASST
export type HistoryItemContext = {
  botid: string;
  user: string;
}

export type WordReplacement = {
  word: string,
  replacement: string
}

export type BotMessageFeedback<ID = string> = {
  _id: ID,
  botId: ID,
  remark: 'thumbsup' | 'thumbsdown',
  messages: HistoryItemResponse[],
  created: Date,
  creator?: ID
}

export type ServerChatbotConfig = ChatbotConfig<ObjectId, Date> & {
  vectorStoreDirty: boolean;
}

export type DefaultResponse = {
  status: 'ok' | 'error' | 'forbidden';
  message?: string;
};

export type ChangelogItem<ID extends MID = string> = {
  _id: ID,
  botId: ID,
  created: Date,
  user: string,
  field: string,
  value: string
}

export type Stat<ID = string> = {
  _id: ID,
  botId: ID,
  userId: ID,
  name: string,
  created: Date
}

export type KIToolsUser<ID = string, D = string> = {
  _id: ID,
  botId: ID
  guestId: string,
  metadata: string,
  accessToken: string
  created: D
  updated: D
  stats: {
    chat: D[]
    audio: D[]
    avatar: D[]
  }
}

export type SelectableUserlistOfBot = {
  botId: string,
  botName: string,
  color: string,
  currentOrg: string,
  users: {
    guestId: string,
    metadata: string
  }[]
}